// @flow

import React from 'react';
import type { ACFListInForm } from '../../../../types';
import { ACFList } from '../../../list';
import { ElementContainer } from '../../../form';

export default (props: ACFListInForm) => (
  <ElementContainer>
    <ACFList {...props} />
  </ElementContainer>
);
